<template>
  <b-table
    :fields="[
      {
        key: 'usuario',
        label: $t('Nome'),
      },
      {
        key: 'parentesco_rf',
        label: $t('Parentesco RF'),
      },
      {
        key: 'descricao',
        label: $t('Descrição'),
      },
      {
        key: 'actions',
        label: '',
        class: 'text-right',
        thStyle: { width: '95px', minWidth: '95px' },
      },
    ]"
    :items="relacionados"
    striped
    hover
    show-empty
    small
    outlined
    stacked="md"
    table-class="mb-3"
    :responsive="true"
  >
    <template v-slot:cell(usuario)="data">
      <strong v-if="data.item.usuario">
        {{ data.item.usuario.nome_completo }}
      </strong>
    </template>

    <template v-slot:cell(parentesco_rf)="data"> {{ data.item.parentesco_rf }} </template>
    <template v-slot:cell(descricao)="data">
      <strong> {{ data.item.descricao }}</strong>
    </template>

    <template v-slot:cell()="data">
      <b-button
        :title="$t('Desvincular')"
        @click.prevent="removerRelacionado(data.item.id, data.index)"
        class="px-2 mb-0 btn-desvincular"
        variant="warning"
        size="xs"
        data-style="zoom-in"
        type="button"
        v-b-tooltip.hover
        :id="'btndesvincular' + data.item.id"
      >
        <i class="fas fa-unlink"></i>
      </b-button>
    </template>
    <template v-slot:empty="scope">
      <div class="text-center my-5">
        <img
          :alt="$t('No results')"
          class="mb-5"
          src="/img/icons/robot.svg"
          style="max-height: 165px"
        />
        <h3 class="bold">{{ $t("No records found") }}</h3>
      </div>
    </template>
  </b-table>
</template>

<script>
export default {
  props: ["atendimentoId", "usuarioId", "relacionados"],
  data() {
    return {
      loading: false,
    };
  },
  methods: {
    removerRelacionado(item, index) {
      let ladda = Ladda.create(document.getElementById("btndesvincular" + item));
      ladda.start();
      axios
        .delete(`api/dashboard/atendimento/usuarios/relacionados/${item}`)
        .then((response) => {
          this.$snack.success({
            button: false,
            text: response.data.message,
          });

          this.relacionados.splice(index, 1);
          ladda.stop();
        })
        .catch((e) => {
          console.log(e);
          ladda.stop();
        });
    },
  },
};
</script>

<style lang="scss" scoped></style>
